export function translateCountMapToString(
  countMap: Map<string, number>,
): string {
  const entries = Array.from(countMap.entries());
  if (entries.length > 1) {
    return '';
  }
  return entries
    .map(([key, value]) => `${value > 1 ? value + 'x ' : ''} ${key}`)
    .join(', ');
}
